import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';
import { ApiResponse } from '../types/api';

export interface MonthlyClimateProjection {
  year: number;
  month: number;
  ensemble_mean: number;
  ensemble_min: number;
  ensemble_max: number;
  model_count: number;
}

export interface ClimateExtremeScenario {
  decade: string;
  date: string;
  model_name: string;
  temperature: number;
  humidity: number;
  wind_speed: number;
  drought_factor: number;
  fire_danger_rating: number;
}

export const useMonthlyClimateProjections = (projectId: string) => {
  const query = useQuery({
    queryKey: ['monthlyClimateProjections', projectId],
    queryFn: () => api.request<ApiResponse<MonthlyClimateProjection[]>>(
      `/api/weather/climate-projections/monthly-fdi?project_id=${projectId}`
    ),
    enabled: !!projectId,
  });
  
  return {
    data: query.data?.data || [],
    isLoading: query.isLoading,
  };
};

export const useClimateExtremeScenarios = (projectId: string) => {
  const query = useQuery({
    queryKey: ['climateExtremeScenarios', projectId],
    queryFn: () => api.request<ApiResponse<ClimateExtremeScenario[]>>(
      `/api/weather/climate-projections/extreme-scenarios?project_id=${projectId}`
    ),
    enabled: !!projectId,
  });
  
  return {
    data: query.data?.data || [],
    isLoading: query.isLoading,
  };
};
